import { z } from 'zod';
import { requiredOutput } from 'src/components/form/zod-utilities';

export const getCapacityOverviewPageParamsSchema = ({
  startDefault,
  endDefault,
  capacityPoolIdDefault,
}: {
  startDefault: string;
  endDefault: string;
  capacityPoolIdDefault: string | null;
}) =>
  z.object({
    runtimeIntersectionFilterStart: z
      .string()
      .nullable()
      .transform(requiredOutput())
      .default(startDefault),
    runtimeIntersectionFilterEnd: z
      .string()
      .nullable()
      .transform(requiredOutput())
      .default(endDefault),
    capacityPoolId: z.string().nullable().default(capacityPoolIdDefault),
  });
